import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./Context/UserContext";
import { ClientProvider } from "./Context/ClientContext";
import { ActifProvider } from "./Context/ActifContext";
import { LivrableProvider } from "./Context/LivrableContext";
import { AuthProvider } from "./Context/AuthContext";
import { ServiceProvider } from "./Context/ServiceContext";
import { SecteurProvider } from "./Context/SecteurContext";
import { FonctionProvider } from "./Context/FonctionContext";
import { PageProvider } from "./Context/PageContext";
import { msalInstance } from "./msalConfig";
import { setAuthToken, instance } from "./api";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", flexDirection: "column", gap: "16px" }}>
    <div style={{
      width: 40,
      height: 40,
      border: "4px solid #e0e0e0",
      borderTop: "4px solid #b71c1c",
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite",
    }} />
    <p style={{ color: "#555", fontSize: 14 }}>Chargement en cours...</p>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then(async (response) => {
  //alert("MSAL response: " + JSON.stringify(!!response));  // ← ALERT pour debug

  if (response && response.account) {
    //alert("Account: " + response.account.username);  // ← debug
    try {
      const tokenResponse = await msalInstance.acquireTokenSilent({
        scopes: ["openid", "profile", "email"],
        account: response.account,
      });

      const decodeJwt = (token) => {
        try {
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
            atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
          );
          return JSON.parse(jsonPayload);
        } catch (e) { return {}; }
      };

      const claims = decodeJwt(tokenResponse.idToken);

      const res = await instance.post("/api/utilisateurs/login365", {
        username: response.account.username,
        email: response.account.username,
        token: tokenResponse.idToken,
        iat: claims.iat || null,
        exp: claims.exp || null,
      });

      const token = res.data.token;
      localStorage.setItem("tokenL", token);
      sessionStorage.setItem("token", token);
      setAuthToken(token);

      // ✅ Redirection vers /carte
      window.location.replace("/carte");
      return; // Ne pas rendre l'app, on redirige
    } catch (err) {
      console.error("Erreur login365:", err);
    }
  }

  // Rendre l'app normalement
  root.render(
    <AuthProvider>
      <UserProvider>
        <SecteurProvider>
          <FonctionProvider>
            <ClientProvider>
              <ActifProvider>
                <ServiceProvider>
                  <PageProvider>
                    <LivrableProvider>
                      <App />
                    </LivrableProvider>
                  </PageProvider>
                </ServiceProvider>
              </ActifProvider>
            </ClientProvider>
          </FonctionProvider>
        </SecteurProvider>
      </UserProvider>
    </AuthProvider>
  );
}).catch((err) => {
  console.error("MSAL error:", err);
  root.render(
    <AuthProvider>
      <UserProvider>
        <SecteurProvider>
          <FonctionProvider>
            <ClientProvider>
              <ActifProvider>
                <ServiceProvider>
                  <PageProvider>
                    <LivrableProvider>
                      <App />
                    </LivrableProvider>
                  </PageProvider>
                </ServiceProvider>
              </ActifProvider>
            </ClientProvider>
          </FonctionProvider>
        </SecteurProvider>
      </UserProvider>
    </AuthProvider>
  );
});

reportWebVitals();
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
}
